import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { AuthenticationService } from "../../_services";
import { first } from 'rxjs/operators';

@Component({
  selector: 'app-new-login',
  templateUrl: './new-login.component.html',
  styleUrls: ['./new-login.component.scss']
})
export class NewLoginComponent implements OnInit {
  loginForm: FormGroup;
  forgotPasswordForm: FormGroup;
  user: any;
  error: any;
  loading: any = false;
  hide = true;
  htmlVide: any;
  submitted = false;


  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private http: HttpClient,
    private authenticationService: AuthenticationService,
    private route: ActivatedRoute
  ) {
    if (this.authenticationService.currentUserValue) {
      this.router.navigate(['/']);
    }
  }

  ngOnAfter(): void { }

  ngOnInit(): void {
    var video = document.getElementById('srcvid');
    this.loadLoginForm();
    this.loadForgotPasswordForm();
  }

  loadLoginForm() {
    this.loginForm = this.formBuilder.group({
      username: new FormControl('', Validators.compose([Validators.required])),
      password: new FormControl('', Validators.compose([Validators.required])),
    });
  }

  loadForgotPasswordForm() {
    this.forgotPasswordForm = this.formBuilder.group({
      username: new FormControl('', Validators.compose([Validators.required])),
    });
  }

  get f(){
    return this.loginForm.controls;
  }

  onSubmit() {
    this.submitted = true;
    if (this.loginForm.invalid) {
      return;
    }
    this.loading = true;
    this.authenticationService.login(this.f.username.value, this.f.password.value)
      .pipe(first())
      .subscribe({
        next: () => {
          /*  window.location.href = '/user/units' */
          if (
            this.authenticationService.currentUserValue.role === 'User'
          ) {
            // get return url from route parameters or default to '/'
            // const returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/user/vehicule';

            localStorage.setItem('startDateValue', new Date().toString());
            localStorage.setItem('endDateValue', new Date().toString());

              window.location.href = '/user/vehicule';

          } else if (
            this.authenticationService.currentUserValue.role === 'Admin'
          ) {
            // get return url from route parameters or default to '/'
            //const returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/admin/device';
            window.location.href = '/admin/device';
            /* this.loading = false;
                    this.spinner.hide(); */
          }
          // const returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/admin/device';
          // this.router.navigate([returnUrl]);
        },
        error: error => {
          this.error = error;
          this.loading = false;
        }
      });
  }

  resetPassword(value: any) {
    console.log(value);
  }

  forgotPassword(){

  }

}
